// 粉丝小程序
import Cookie from '../utils/cookie';
import Url from '../utils/url';
export default {
  appName: 'wxapp_fans',
  useKNB: false,
  sellChannel: 21,
  theme: 'maoyan',
  ajaxUrl: '//m.dianping.com/myshow/ajax',
  ajaxBetaUrl: '//m.51ping.com/myshow/ajax',
  getUserInfo: function getUserInfo() {
    return {
      token: Url.getQuery('token') || Url.getQuery('_token') || Url.getHashQuery('_token') || Cookie.get('_token'),
      openId: Url.getQuery('openId') || Url.getQuery('_openId') || Url.getHashQuery('_openId')
    };
  },
  getLocation: function getLocation() {
    return {
      lat: Url.getQuery('_lat') || Url.getHashQuery('_lat'),
      lng: Url.getQuery('_lng') || Url.getHashQuery('_lng')
    };
  },
  getCity: function getCity() {
    return {
      cityId: Url.getQuery('_cityId') || Url.getHashQuery('_cityId')
    };
  }
};